import { testimonials } from '../../../mocks/testimonials';

export default function RefTestimonials() {
  return (
    <section className="py-20 bg-zinc-900/50 border-t border-zinc-800/60">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-zinc-500 text-sm uppercase tracking-widest font-semibold mb-2">Klientska spätná väzba</p>
          <h2 className="text-white text-3xl md:text-4xl font-black">
            Neveríte nám? Opýtajte sa ich.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-zinc-900 border border-zinc-800/60 rounded-2xl p-6 hover:border-zinc-700/60 transition-all duration-300"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-orange-400 text-sm" />
                ))}
              </div>
              <p className="text-zinc-300 text-sm leading-relaxed mb-5">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="inline-flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-3 py-1 mb-5">
                <i className="ri-arrow-up-line text-emerald-400 text-xs" />
                <span className="text-emerald-400 text-xs font-bold">{t.metric}</span>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-zinc-800/60">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-zinc-800">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">{t.name}</p>
                  <p className="text-zinc-500 text-xs">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
